module.exports = __webpack_public_path__ + "static/media/comet.ff5fcf39.svg";


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/comet/comet.svg
// module id = 7
// module chunks = 0